import axios from 'axios';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { SESSION_TOKEN } from '../constants';
import voebizGetPromotionalMock from '../mocks/voebizGetPromotionalMock.json';

const contentType = 'application/json';

export const VoeBizApi = () => {
  const token = localStorage.getItem(SESSION_TOKEN);
  const vbzDebug = localStorage.getItem('vbzDebug');

  return {
    getPromotion: async (apiDomain: string, promotionalId: string, cnpj: string) => {
      if (vbzDebug) {
        const resultData = voebizGetPromotionalMock;
        return { success: true, response: resultData };
      }

      return axios
        .post(
          `${apiDomain}/b2b/v1/member/promotion`,
          {
            cnpj,
            promotionalId,
          },
          {
            headers: {
              'Content-Type': contentType,
              ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
          },
        )
        .then((response) => {
          return { success: true, response: { data: response.data } };
        })
        .catch((error) => {
          return { success: false, response: error };
        });
    },
  };
};
